import moneyFormat from "./moneyFormart.js";
import { dangerTransfer } from "./safeJoin.js";

// utils
let isArray = arraylike => arraylike instanceof Array;
// isPromise
const isPromise = p => Object.prototype.toString.call(p) === "[object Promise]";
// sleep
const sleep = (delay = 1000) => {
  return new Promise(function (resolve, reject) {
    setTimeout(() => {
      resolve(null);
    }, delay);
  });
};

/**
 * Class decorator
 * page loading
 *
 * 为「类」添加一个名为 ‘loading’ 的私有属性
 */
export function loading(defaulValue = false) {
  return function (constructor) {
    constructor.prototype.loading = defaulValue;
  };
}

/**
 * method decorator
 * loadingCatch
 *
 * 为「类」添加一个名为 ‘loading’ 的私有属性
 */
export function loadingCatch(target, name, descriptor) {
  const fn = target[name];

  descriptor.value = async function (...args) {
    try {
      this.loading = true;

      // 执行结果可能是一个 promise
      let processFn = fn.call(this, ...args);

      if (isPromise(processFn)) {
        await processFn;
      }
    } catch (error) {
      console.error(error);
    } finally {
      // 在页面上达到一个loading的效果
      await sleep(200);

      this.loading = false;
    }
  };
}
/**
 * method decorator
 * promisely
 *
 * 将异步函数转为Promisely style function
 */
export function promisely(target, name, descriptor) {
  const fn = target[name];

  descriptor.value = function () {
    return new Promise((resolve, reject) => {
      fn.call(this, resolve, reject);
    });
  };
}

/**
 * method decorator
 * pagination
 *
 * element-ui's pagination comp 的一连串方法和属性
 * currentPage 和 pageNum的意义相同
 * 同时有currentPage 和 pageNum是为了向后兼容
 */

export function pagination(
  fetchFnName = "getData",
  {
    pageSizes = [5, 10, 20, 50, 100, 200],
    currentPage = 1,
    pageNum = 1,
    pageSize = 10,
    layout = "total, sizes, prev, pager, next, jumper"
  } = {}
) {
  return function (constructor) {
    let _proto_ = constructor.prototype;

    _proto_.pageSizes = pageSizes;
    _proto_.currentPage = currentPage;
    _proto_.pageNum = pageNum;
    _proto_.pageSize = pageSize;
    _proto_.total = 0;
    _proto_.layout = layout;

    _proto_.handleSizeChange = function (size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.pageNum = 1;
      this[fetchFnName].call(this);
    };

    _proto_.handlePageChange = function (page) {
      this.currentPage = page;
      this.pageNum = page;
      this[fetchFnName].call(this);
    };
  };
}

/**
 * 向外提供可验证本组件内表单函数
 *
 * Use：
 * el-form的model选项中传入的formName 需要和el-form的ref选项传入的formName 是同名的
 *
 * todo
 * 用父元素提供了registerVaildateHandle方法
 *
 */
export function FormVaildateToOut(
  formName = "form",
  {
    vaildErrorCallbackName = "",
    vaildSuccessCallbackName = "",
    resCbName = ""
  } = {}
) {
  return function (constructor) {
    let _proto_ = constructor.prototype;

    // methods: 表单验证
    _proto_.handleVaildate = function () {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate(vaild => {
          let res =
            resCbName && this[resCbName]
              ? this[resCbName](this[formName])
              : this[formName];

          if (vaild) {
            vaildSuccessCallbackName
              ? this[vaildSuccessCallbackName](resolve, this[formName])
              : resolve(res);
          } else {
            vaildErrorCallbackName
              ? this[vaildErrorCallbackName](reject, this[formName])
              : reject(res);
          }
        });
      });
    };

    // 表单的整体clearValidate
    _proto_.clearValidate = function () {
      this.$refs[formName].clearValidate();
    };

    // // 向父组件注册表单验证函数
    // _proto_.vaildateRegisterAuto = function() {
    //   if (this.vaildateRegister) {
    //     this.vaildateRegister(this.handleVaildate);
    //   }
    // };

    // // 从父组件的表单验证函数数组注销
    // _proto_.vaildateRemoveAuto = function() {
    //   if (this.vaildateRemove) {
    //     this.vaildateRemove(this.handleVaildate);
    //   }
    // };
  };
}

export function SearchbarControl(
  defaultFormName = "searchForm",
  searchHandleName = "handlePageChange"
) {
  return function (constructor) {
    let _proto_ = constructor.prototype;

    _proto_.onSearchBtnClick = function () {
      // default method of "handlePageChange" come from the decorator named "pagination" which need one param
      this[searchHandleName](1);
    };

    _proto_.onResetBtnClick = function () {
      const $form = this.$refs[defaultFormName];
      $form && $form.resetFields();
      this.onSearchBtnClick();
    };
  };
}

/**
 *
 * @decorator
 * @param {*} isMore
 * @returns
 */
export function IsMore(val = false) {
  return function (constructor) {
    let _proto_ = constructor.prototype;
    _proto_.isMore = val;
    _proto_.icon = "el-icon-arrow-down";

    _proto_.handleToggleSearchbar = function () {
      this.isMore = !this.isMore;
      this.icon = this.isMore ? "el-icon-arrow-up" : "el-icon-arrow-down";
    };
  };
}

/**
 * 用户在el-table的无值的列中显示 ”-“
 */
export function PlaceholderInTabel(constructor) {
  constructor.prototype.emptyTextFormart = function (row, column, cellValue) {
    if (cellValue === "" || cellValue === undefined || cellValue === null) {
      return "-";
    } else {
      return cellValue;
    }
  };

  constructor.prototype.moneyFormart = function (row, column, cellValue) {
    return moneyFormat(dangerTransfer(cellValue));
  };
}

/**
 * 用于向 Store 中添加 字典 和 字典对应的MAP
 */
let queryJoin = (list, lang) => {
  return list
    .map(ddCode => {
      return `
            ${ddCode}: queryDataDictionaryListLang(input: { ddCode: "${ddCode}", lang: "${lang}" } ) {
              value: ddValue
              label: ddText
            }`;
    })
    .join(",");
};

/**
 * elTableCellEmptyFormatter
 *
 * 在使用el-table的时候 有些cell对应的
 */
/**
 * 处理分页的方法装饰器
 * @param options
 */
export const handlePaginationDecorator = (options?: any) => {
  return function (
    target: any,
    propertyName: string,
    propertyDescriptor: PropertyDescriptor
  ): PropertyDescriptor {
    const {
      totalField = "total", // 组件内总数量属性名
      listField = "list", // 组件内数组属性名
      fnName = "fnName", // 组件内请求函数名
      fnParams = "fnParams", // 组件内请求参数变量名 / 函数名
      resTotalField = "total", //  返回总数量属性名
      resListField = "list" // 返回数组属性名
    } = options || {};

    const method = propertyDescriptor.value;
    // 重载方法
    propertyDescriptor.value = async function () {
      // 新语法
      const isNewSyntax = !!this.pagingParams;
      // 获取请求分页参数
      const getPageInputParams = () => {
        if (isNewSyntax) {
          const { pageSize, pageNum } = this.pagingParams;
          return { pageSize, pageNum };
        } else {
          const { pageSize, currentPage: pageNum } = this;
          return { pageSize, pageNum };
        }
      };
      try {
        if (!this[fnName]) return;
        this.loading = true;

        const params =
          typeof this[fnParams] === "function"
            ? this[fnParams]()
            : this[fnParams];

        const res = await this[fnName].call(this, {
          // 设置分页参数
          pageInput: getPageInputParams(),
          ...params
        });
        // 设置分页数据
        this[totalField] = res[resTotalField];
        this[listField] = res[resListField];
        // 执行原函数
        return await method.call(this);
      } finally {
        this.loading = false;
      }
    };
    return propertyDescriptor;
  };
};
